// Torque units with conversion factors to newton meter (N·m)
export const torqueUnits = [
  { id: 'newton-meter', name: 'Newton Meter', symbol: 'N·m', plural: 'Newton Meters', factor: 1 },
  { id: 'newton-centimeter', name: 'Newton Centimeter', symbol: 'N·cm', plural: 'Newton Centimeters', factor: 0.01 },
  { id: 'newton-millimeter', name: 'Newton Millimeter', symbol: 'N·mm', plural: 'Newton Millimeters', factor: 0.001 },
  { id: 'kilonewton-meter', name: 'Kilonewton Meter', symbol: 'kN·m', plural: 'Kilonewton Meters', factor: 1000 },
  { id: 'dyne-meter', name: 'Dyne Meter', symbol: 'dyn·m', plural: 'Dyne Meters', factor: 0.00001 },
  { id: 'dyne-centimeter', name: 'Dyne Centimeter', symbol: 'dyn·cm', plural: 'Dyne Centimeters', factor: 0.0000001 },
  { id: 'dyne-millimeter', name: 'Dyne Millimeter', symbol: 'dyn·mm', plural: 'Dyne Millimeters', factor: 0.00000001 },
  { id: 'kilogram-force-meter', name: 'Kilogram-force Meter', symbol: 'kgf·m', plural: 'Kilogram-force Meters', factor: 9.80665 },
  { id: 'kilogram-force-centimeter', name: 'Kilogram-force Centimeter', symbol: 'kgf·cm', plural: 'Kilogram-force Centimeters', factor: 0.0980665 },
  { id: 'kilogram-force-millimeter', name: 'Kilogram-force Millimeter', symbol: 'kgf·mm', plural: 'Kilogram-force Millimeters', factor: 0.00980665 },
  { id: 'gram-force-meter', name: 'Gram-force Meter', symbol: 'gf·m', plural: 'Gram-force Meters', factor: 0.00980665 },
  { id: 'gram-force-centimeter', name: 'Gram-force Centimeter', symbol: 'gf·cm', plural: 'Gram-force Centimeters', factor: 0.0000980665 },
  { id: 'gram-force-millimeter', name: 'Gram-force Millimeter', symbol: 'gf·mm', plural: 'Gram-force Millimeters', factor: 0.00000980665 },
  { id: 'ounce-force-foot', name: 'Ounce-force Foot', symbol: 'ozf·ft', plural: 'Ounce-force Feet', factor: 0.08474043 },
  { id: 'ounce-force-inch', name: 'Ounce-force Inch', symbol: 'ozf·in', plural: 'Ounce-force Inches', factor: 0.00706170248 },
  { id: 'pound-force-foot', name: 'Pound-force Foot', symbol: 'lbf·ft', plural: 'Pound-force Feet', factor: 1.3558179483 },
  { id: 'pound-force-inch', name: 'Pound-force Inch', symbol: 'lbf·in', plural: 'Pound-force Inches', factor: 0.1129848290276 },
];

export const popularTorqueConversions = [
  { from: 'newton-meter', to: 'pound-force-foot' },
  { from: 'pound-force-foot', to: 'newton-meter' },
  { from: 'newton-meter', to: 'kilogram-force-meter' },
  { from: 'kilogram-force-meter', to: 'newton-meter' },
  { from: 'pound-force-inch', to: 'newton-meter' },
  { from: 'newton-meter', to: 'pound-force-inch' },
  { from: 'kilonewton-meter', to: 'newton-meter' },
  { from: 'kilogram-force-centimeter', to: 'newton-meter' },
  { from: 'newton-centimeter', to: 'pound-force-inch' },
  { from: 'ounce-force-inch', to: 'newton-centimeter' },
];

export const getUnitById = (id) => torqueUnits.find(unit => unit.id === id);

export const convertTorque = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert ${fromUnit.plural.toLowerCase()} (${fromUnit.symbol}) to ${toUnit.plural.toLowerCase()} (${toUnit.symbol}) and learn the conversion formula.`;
};
